<template>
  <div>
    <CanvasApp/>
    <div :class="$style.footer" v-if="!user">
      <div></div>
      <div>
        <div
          :class="$style.footerButton"
          @click="$emit('setActiveModal', 'LogIn')"
        >Log In</div>
        <div
          :class="$style.footerButton"
          @click="$emit('setActiveModal', 'Register')"
        >Create Account</div>
      </div>
    </div>
  </div>
</template>


<script>
import { mapState } from 'vuex';
import CanvasApp from '@/components/canvas/App'

export default {
  computed: mapState(['user', 'canvasOutput']),
  components: { CanvasApp }
}
</script>


<style lang="scss" module>
.footer {
  display: flex;
  justify-content: space-between;
  font-size: 12px;
  margin-top: 20px;
}

.footerButton {
  display: inline-block;
  cursor: pointer;
  color: rgb(84, 155, 212);
  margin-left: 20px;
  transition: .2s;
  &:hover { color: rgb(40, 96, 143); }
}
</style>
